import { Component, Input, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { BaseClass } from 'src/app/shared/classes/base';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { QuestionConfig } from 'src/app/shared/interfaces/process-config.interface';
@Component({
  selector: 'app-calibration-evaluation-answer',
  templateUrl: './evaluation-answer.component.html',
  styleUrls: ['../qualitative-evaluation.component.scss'],
})
export class CalibrationUserEvaluationAnswer extends BaseClass
  implements OnInit {
  @Input() question: QuestionConfig;
  @Input() possibleValues?: Array<string>;
  currentLanguage: string;
  Matrix: Array<Array<Number>> = [];

  constructor(
    protected _toastController: ToastController,
    protected _translationService: TranslationService
  ) {
    super(_toastController, _translationService);
    this.currentLanguage = _translationService.getSelectedLanguage();
  }

  public separateAnswers(str: string) {
    const temp = str.trim().split(new RegExp('[\n]', 'g'));
    temp.forEach((element, index) => {
      if (element === '' || element === ' ') {
        temp.splice(index, 1);
        if(index == temp.length -1)
          temp[index] += '.'
      }
    });
    return temp;
  }

  ngOnInit() {
    this.possibleValues =
      this.question.typeConfig &&
      this.question.typeConfig.possibleValuesGlobalized
        ? this.question.typeConfig.possibleValuesGlobalized[
            this.currentLanguage
          ]
        : this.possibleValues;

    this.CreateMatrix(this.question.groupedValues);
  }

  public CreateMatrix(matrix) {
    if (matrix == null) {
      return;
    }
    const numberMatrix: Array<Array<Number>> = [];

    matrix.forEach((element, index) => {
      numberMatrix.push(Array<number>());
      element.forEach((element2) => {
        numberMatrix[index].push(element2.total);
      });
    });

    this.Matrix = numberMatrix;
  }
}
